import React, { useState } from "react";
import { Search } from "lucide-react";
import Input from "./Input";

interface SearchAreaProps {
  onSearch?: (query: string) => void;
}

const SearchArea: React.FC<SearchAreaProps> = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch?.(query);
  };

  return (
    <div className="space-y-2">
      <label className="text-grey-dark dark:text-muted-foreground text-sm" data-cypress-id={"searchAreaLabel"}>
        Search your artwork
      </label>
      <div className="relative w-52">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-secondary-deep-blue dark:text-muted-foreground transition-all duration-200 ease-in-out group-hover:scale-110" />
        <Input
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="pl-10 border-light-blue dark:border-border focus:border-blue-light transition-all duration-200 ease-in-out hover:border-secondary-deep-blue hover:shadow-md focus:shadow-lg"
          data-cypress-id={"searchAreaInput"}
        />
      </div>
    </div>
  );
};

export default SearchArea;
